import ReadonlyView from '@/components/form/readonly-view';
import { ReadonlyField } from '@/components/form/readonly-view/helpers';
import { GroupModel } from '@/lib/models/group.model';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { getNiceNumber } from '@/lib/helpers';
import { StaticDashboard } from '@/components/metabase/StaticDashboard';
import useMetabase from '@/hooks/use-metabase';
import Chip from '@/components/chip';
import NoneChip from '@/components/chip/none-chip';

interface Props {
  group: GroupModel;
}

const fields: ReadonlyField[] = [
  { label: 'Name', prop: 'name' },
  { label: 'Description', prop: 'description' },
  { label: 'Users', prop: 'userCount' },
  { label: 'Source', prop: 'source' },
  { label: 'Quick Insights', prop: 'quickInsights', propType: 'section' },
  { label: '', prop: 'insights' },
];

const getReadonlyData = (data: GroupModel | null, dashboardId: string) => {
  if (!data) {
    return {};
  }

  const { sourceLabel, userCount, name, description, hasDuplicateName } = data;
  const NaChipEl = <NoneChip />;

  return {
    name: (
      <Stack direction="row" gap={1}>
        {name}
        {hasDuplicateName && <Chip label="Duplicate Group Name" size="small" color="warning" />}
      </Stack>
    ),
    description: description || NaChipEl,
    source: sourceLabel,
    userCount: getNiceNumber(userCount),
    insights: (
      <StaticDashboard
        dashboardId={dashboardId}
        initialParameters={{ group: name }}
        hiddenParameters={['email', 'group']}
        isDrawer
      />
    ),
  };
};

export const GroupDetails: FC<Props> = ({ group }) => {
  const { dashboards } = useMetabase();
  const { id: dashboardId } = dashboards.userGroupSmall;

  const data = getReadonlyData(group, dashboardId);

  return <ReadonlyView fields={fields} data={data} />;
};

export default GroupDetails;
